export enum Environments {
  Development = 'development',
  Production = 'production',
  Staging = 'staging',
}
